module.exports = __webpack_public_path__ + "img/lt09.9f3a1ab5.webp";